import React from "react"
import * as styles from "./index.module.less"

const RichText = ({ data }) => {
  if (!data || !data.body) return null
  return (
    <div className={styles.whats_included}>
      <div className="container">
        <div className="row">
          <div className="col-sm-9">
            <div dangerouslySetInnerHTML={{ __html: data.body }} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default RichText
